import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Button from "../../components/common/button/Button";
import Detail from "../../components/common/detail/Detail";
import { getDetailData } from "../../models/employeeModel";
import {fetchEmployeeById} from "../../store/employee-slice";
import {getValidatedLimit} from "../../components/Utility";

const EmployeeDetail = () => {
    const params = useParams();
    const dispatch = useDispatch();
    const {pagination} = useSelector(state => state.employee);
    const {limit, currentPage} = getValidatedLimit(pagination);

    useEffect(() => {
        dispatch(fetchEmployeeById(params.employeeId));
    }, [dispatch, params.employeeId,]);

    const {
        items,
        fetchByIdStatus,
        error
    } = useSelector(state => state.employee);


    const item = items.find(item => item.id === params.employeeId);
    const detailData = getDetailData({ item });

    return (
        <>
            <SubHeader title="Employee Details">
                <Button to={`../?page=${currentPage}&limit=${limit}`} className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                {fetchByIdStatus === "loading" && <p>Loading...</p>}
                {fetchByIdStatus === "failed" && <h6 className="text-danger">{error}</h6>}
                {fetchByIdStatus === "success" && <Detail inline={true} columns={{ lg: 9, xl: 7 }} data={detailData} />}
            </div>
        </>
    );
};

export default EmployeeDetail;
